<template>
  <div></div>
</template>
<script>
import protoComponent from './proto'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'

export default {
  name: 'SlAmapShape',
  extends: protoComponent,
  data() {
    return {
      polyline: null,
      polygon: null,
      Circle: null,
      rectangle: null,
      ellipse: null,
      marker: null,
      SimpleMarkerData: [],
    }
  },

  props: {
    center: {
      type: Array,
      class: 'latlng'
    },
    cs: {
      type: String,
      default: 'gcj02'
    },
  },
  methods: {
    $initComponent(options) {

    },
    $setCenter(v) {

    },
    $convCenter(v) {
      if (v) {
        return new AMap.LngLat(...(this.cs == 'wgs84' ? wgs2gcj(...v) : v))
      } else {
        return undefined
      }
    },
    clearShape() {
      let map = this.$amap
      if (this.polyline) {
        map.remove(this.polyline);
      }
      if (this.polygon) {
        map.remove(this.polygon);
      }
      if (this.Circle) {
        map.remove(this.Circle);
      }
      if (this.rectangle) {
        map.remove(this.rectangle);
      }
      if (this.ellipse) {
        map.remove(this.ellipse);
      }

    },
    /**
    显示一个点
    */
    initMarker(data) {
      let map = this.$amap
      if (this.marker) {
        map.remove(this.marker);
      }
      if (!data[0]) {
        return
      }
      // wgs2gcj = (wgLon , wgLat)
      this.marker = new AMap.Marker({
        position: wgs2gcj(...data),
        // content: '<div class="sl-amap-marker-default"></div>',
        offset: new AMap.Pixel(-13, -30)
      });

      this.marker.setMap(this.$amap);
      // this.$amap.setCenter(data)
    },
    /**
    同时显示多个点
    */
    initSimpleMarker(data, iconOption) {
      let _this = this
      let map = this.$amap
      if (!data[0]) {
        return
      }
      let option = {
        position: wgs2gcj(...data),
        map: map
      }


      if (iconOption) {
        option = {
          position: wgs2gcj(...data),
          map: map,
          ...iconOption
        }
      }
      AMapUI.loadUI(['overlay/SimpleMarker'], function(SimpleMarker) {
        let marker = new SimpleMarker(option);
        map.setFitView()
        _this.SimpleMarkerData.push(marker)
      })
    },
    /**
    清除多个marksers
    */
    clearSimpleMarker() {
      let map = this.$amap
      this.SimpleMarkerData.forEach((marker) => {
        if (marker) {
          // 移除已创建的 marker
          map.remove(marker)
        }
      })
    },
    /**
    自动适配到合适视野范围
    */
    setFitView() {
      let map = this.$amap
      // 自动适配到合适视野范围
      // 无参数，默认包括所有覆盖物的情况
      map.setFitView();
    },
    initShapeType(type, data) {
      this.clearShape()
      if (!type) { return }
      // 折线覆盖物 Polyline 、 多边形覆盖物 Polygon 、圆形覆盖物 Circle 、矩形覆盖物 Rectangle 、 椭圆形覆盖物 Ellipse

      switch (type) {
        case 'Polyline':
          this.drawPolyline(data)
          break
        case 'Polygon':
          this.drawPolygon(data)
          break
        case 'Circle':
          this.drawCircle(data)
          break
        case 'Rectangle':
          this.drawRectangle(data)
          break
        case 'Ellipse':
          this.drawEllipse(data)
          break
      }
    },
    drawPolyline(data) {
      let map = this.$amap

      // 折线的节点坐标数组，每个元素为 AMap.LngLat 对象
      // var path = [
      //   new AMap.LngLat(116.368904, 39.913423),
      //   new AMap.LngLat(116.382122, 39.901176),
      //   new AMap.LngLat(116.387271, 39.912501),
      //   new AMap.LngLat(116.398258, 39.904600)
      // ];

      var path = [];
      data.forEach(item => {
        let one = new AMap.LngLat(...wgs2gcj(...item))
        path.push(one)
      })

      // 创建折线实例
      var polyline = new AMap.Polyline({
        path: path,
        borderWeight: 2, // 线条宽度，默认为 1
        strokeColor: 'red', // 线条颜色
        lineJoin: 'round' // 折线拐点连接处样式
      });
      this.polyline = polyline

      // 将折线添加至地图实例
      map.add(polyline);
    },
    drawPolygon(data) {
      let map = this.$amap

      // 多边形轮廓线的节点坐标数组
      // var path = [
      //   new AMap.LngLat(116.368904, 39.913423),
      //   new AMap.LngLat(116.382122, 39.901176),
      //   new AMap.LngLat(116.387271, 39.912501),
      //   new AMap.LngLat(116.398258, 39.904600)
      // ];

      var path = [];
      data.forEach(item => {
        let one = new AMap.LngLat(...wgs2gcj(...item))
        path.push(one)
      })

      var polygon = new AMap.Polygon({
        path: path,
        fillColor: 'grey', // 多边形填充颜色
        borderWeight: 2, // 线条宽度，默认为 1
        strokeColor: 'grey', // 线条颜色
        fillOpacity: 0.5,
        // strokeStyle: 'dashed',
      });

      this.polygon = polygon

      map.add(polygon);

      // 缩放地图到合适的视野级别
      map.setFitView([polygon])
    },
    drawCircle(obj) {
      let map = this.$amap

      var Circle = new AMap.Circle({
        center: wgs2gcj(...obj.data),
        radius: obj.radius,
        strokeColor: 'grey',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillColor: 'grey',
        fillOpacity: 0.5,
        zIndex: 10,
        bubble: true,
        cursor: 'pointer',
        clickable: true,
        // strokeStyle: 'dashed',
      })
      this.Circle = Circle

      map.add(Circle);
      // 缩放地图到合适的视野级别
      map.setFitView([Circle])
    },
    drawRectangle(data) {
      let map = this.$amap

      // var southWest = new AMap.LngLat(116.356449, 39.859008)
      // var northEast = new AMap.LngLat(116.417901, 39.893797)
      var southWest = new AMap.LngLat(...wgs2gcj(...data[0]))
      var northEast = new AMap.LngLat(...wgs2gcj(...data[1]))

      var bounds = new AMap.Bounds(southWest, northEast)

      var rectangle = new AMap.Rectangle({
        bounds: bounds,
        strokeColor: 'grey',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        strokeDasharray: [30, 10],
        // strokeStyle还支持 solid
        // strokeStyle: 'dashed',
        fillColor: 'grey',
        fillOpacity: 0.5,
        cursor: 'pointer',
        zIndex: 50,
      })
      this.rectangle = rectangle

      rectangle.setMap(map)
      // 缩放地图到合适的视野级别
      map.setFitView([rectangle])
    },
    drawEllipse(data) {
      let map = this.$amap

      var ellipse = new AMap.Ellipse({
        center: [116.433322, 39.900255],
        radius: [2000, 1000], //半径
        borderWeight: 3,
        strokeColor: "#FF33FF",
        strokeOpacity: 1,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        // 线样式还支持 'dashed'
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        fillColor: '#1791fc',
        zIndex: 50,
      })
      this.ellipse = ellipse

      ellipse.setMap(map)
      // 缩放地图到合适的视野级别
      map.setFitView([ellipse])
    },
  },
  destroyed() {

  },
  beforeDestroy() {

  }
};

</script>
<style>
.amap-marker-label {
  border: 0;
  background-color: transparent;
}

</style>
